import { Link } from '~/utils/navigation';
import styled from 'styled-components';
import { Pill, BadgeRoundedSecondary } from '@comeon/ui';
import { motion, MotionProps } from 'motion/react';

const AnimatedLinkWrapper = styled(motion.div)``;

const StyledLink = styled(Link)`
	position: relative;
	padding: 4px 0; // Extend clickable area a bit. Also used to prevent badge from cropping.
`;

const StyledPill = styled(Pill)`
	min-width: 62px;
`;

const Badge = styled(BadgeRoundedSecondary)`
	position: absolute;
	z-index: 2;
	right: 0;
	top: 0;
	border-radius: 8px;
`;

const linkAnimation: MotionProps = {
	variants: {
		tap: {
			scale: [1.0, 0.9, 0.88, 0.86, 0.85, 0.84, 0.88, 1.0],
			opacity: [1.0, 0.9, 0.88, 0.86, 0.85, 0.84, 0.82, 1.0].reverse()
		}
	},
	whileTap: 'tap',
	transition: { type: 'tween' }
};

type Props = {
	id?: string;
	to: string;
	role?: string;
	label: string;
	badgeLabel?: number;
	className?: string;
	dataAt: string;
	isActive: boolean;
	onClick: () => void;
};

const SportsbookTopNavigationLink: React.FC<Props> = ({
	id,
	to,
	role,
	label,
	badgeLabel,
	className,
	dataAt,
	isActive,
	onClick
}) => {
	return (
		<AnimatedLinkWrapper {...linkAnimation}>
			<StyledLink href={to} onClick={onClick} role={role} data-at={dataAt} className={className}>
				{badgeLabel && <Badge>{badgeLabel}</Badge>}
				<StyledPill label={label} id={id} isActive={isActive} />
			</StyledLink>
		</AnimatedLinkWrapper>
	);
};

export default SportsbookTopNavigationLink;
